var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2227 4.34229C13.5391 4.65869 13.75 5.11572 13.75 5.5376V17.2446C13.75 18.1587 12.9766 18.897 12.0273 18.897H1.90234C0.988281 18.897 0.25 18.1587 0.25 17.2446V2.61963C0.25 1.67041 0.988281 0.932129 1.90234 0.896973H9.10938C9.53125 0.896973 9.95312 1.10791 10.2695 1.42432L13.2227 4.34229ZM9.21484 2.7251V5.43213H11.9219L9.21484 2.7251ZM12.0625 17.2446V7.11963H8.37109C7.91406 7.11963 7.52734 6.73291 7.52734 6.27588V2.61963H1.90234V17.2446H12.0625ZM6.64844 8.9126C6.82422 8.73682 7.14062 8.73682 7.31641 8.9126L9.84766 11.4438C10.0938 11.7251 9.91797 12.1821 9.53125 12.1821H7.84375V15.1353C7.84375 15.3462 7.63281 15.5571 7.42188 15.5571H6.57812C6.33203 15.5571 6.15625 15.3462 6.15625 15.1353V12.1821H4.43359C4.04688 12.1821 3.87109 11.7251 4.11719 11.4438L6.64844 8.9126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileArrow);
export default __webpack_public_path__ + "static/media/file-arrow.1af314bd607fb11080bfc6511b3bc1d6.svg";
export { ForwardRef as ReactComponent };